import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext({ theme: "light", toggle: () => {}, setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      return localStorage.getItem("crm_theme") || "light";
    } catch {
      return "light";
    }
  });

  const apply = useCallback((t) => {
    document.documentElement.setAttribute("data-theme", t);
    try { localStorage.setItem("crm_theme", t); } catch { /* ignore */ }
  }, []);

  useEffect(() => { apply(theme); }, [theme, apply]);

  const setTheme = useCallback((t) => setThemeState(t === "dark" ? "dark" : "light"), []);
  const toggle = useCallback(() => setThemeState((t) => (t === "dark" ? "light" : "dark")), []);

  return (
    <ThemeContext.Provider value={{ theme, toggle, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
